/*
 * Copyright (c) 2020. Dave van Rijn Development
 */

import React from 'react';
import {Navigate, RouteObject} from 'react-router';
import App from './app';
import AdminController from './components/admin/adminController';
import DocumentsPageController from './components/admin/documents/documentsPageController';
import ErrorPage from './components/error/errorPage';
import About from './components/pages/about/about';
import YearCalendarController from './components/pages/agenda/yearCalendarController';
import Ambition from './components/pages/ambition/ambition';
import AmstelPage from './components/pages/amstel/amstelPage';
import CalendarController from './components/pages/calendar/calendarController';
import ComplaintsPage from './components/pages/complaints/complaintsPage';
import ContactController from './components/pages/contact/contactController';
import DocumentsController from './components/pages/documents/documentsController';
import Home from './components/pages/home/home';
import LeaveRequestPage from './components/pages/leaveRequest/leaveRequestPage';
import MrPage from './components/pages/mr/mrPage';
import NewslettersController from './components/pages/newsletters/newslettersController';
import OpeningHoursPage from './components/pages/openingHours/openingHoursPage';
import OvPage from './components/pages/ov/ovPage';
import ParentsRoomPage from './components/pages/parentsRoom/parentsRoomPage';
import Quality from './components/pages/quality/quality';
import TeamController from './components/pages/team/teamController';
import ThinkTankPage from './components/pages/thinkTank/thinkTankPage';
import VacanciesController from './components/pages/vacancy/vacanciesController';
import {
    ABOUT_PATH, ABOUT_ROUTE, ADMIN_DOCUMENTS_PATH, ADMIN_PATH, AGENDA_PATH, AGENDA_ROUTE, AMBITION_PATH, AMBITION_ROUTE,
    AMSTEL_PATH, AMSTEL_ROUTE, COMPLAINTS_PATH, COMPLAINTS_ROUTE, CONTACT_PATH, CONTACT_ROUTE, DOCUMENTS_PATH,
    DOCUMENTS_ROUTE, HOME_PATH, HOME_ROUTE, LEAVE_PATH, LEAVE_ROUTE, MR_PATH, MR_ROUTE, NEWSLETTER_PATH,
    NEWSLETTER_ROUTE, OPENING_HOURS_PATH, OPENING_HOURS_ROUTE, OV_PATH, OV_ROUTE, PARENTS_ROOM_PATH, PARENTS_ROOM_ROUTE,
    QUALITY_PATH, QUALITY_ROUTE, REGISTER_PATH, REGISTER_ROUTE, TEAM_PATH, THINK_TANK_PATH, THINK_TANK_ROUTE,
    VACANCIES_PATH, VACANCIES_ROUTE, YEAR_CALENDAR_PATH, YEAR_CALENDAR_ROUTE
} from './util/constants';
import {HeaderItem} from './util/interfaces';
import RegisterPage from "./components/pages/register/registerPage";

export const HeaderItems: Array<HeaderItem> = [
    {label: 'Welkom', route: HOME_ROUTE},
    {
        label: 'Onze school', route: ABOUT_ROUTE, children: [
            {label: 'Aanmelden', route: REGISTER_ROUTE, className: 'btn-register'},
            {label: 'Over ons', route: ABOUT_ROUTE},
            {label: 'Ons kwaliteitsniveau', route: QUALITY_ROUTE},
            {label: 'Onze ambities', route: AMBITION_ROUTE},
            {label: 'Wijzer aan de Amstel', route: AMSTEL_ROUTE},
        ]
    },
    {
        label: 'Praktische informatie', route: REGISTER_ROUTE, children: [
            {label: 'Aanmelden', route: REGISTER_ROUTE, className: 'btn-register'},
            {label: 'Nieuwsbrieven', route: NEWSLETTER_ROUTE},
            {label: 'Agenda', route: AGENDA_ROUTE},
            {label: 'Jaarkalender', route: YEAR_CALENDAR_ROUTE},
            {label: 'Openingstijden', route: OPENING_HOURS_ROUTE},
            {label: 'Oudervereniging (OV)', route: OV_ROUTE},
            {label: 'Medezeggenschapsraad (MR)', route: MR_ROUTE},
            {label: 'Ouderkamer', route: PARENTS_ROOM_ROUTE},
            {label: 'Verlofregeling', route: LEAVE_ROUTE},
            {label: 'Leerlingenraad', route: THINK_TANK_ROUTE},
            {label: 'Klachtenregeling', route: COMPLAINTS_ROUTE},
            {label: 'Documenten', route: DOCUMENTS_ROUTE},
        ]
    },
    {label: 'Werken bij', route: VACANCIES_ROUTE},
    {label: 'Contact', route: CONTACT_ROUTE}
];

export const Routes: Array<RouteObject> = [
    {
        path: '*', element: <App/>, errorElement: <ErrorPage/>, children: [
            {path: HOME_PATH, element: <Home/>},
            {path: ABOUT_PATH, element: <About/>},
            {path: QUALITY_PATH, element: <Quality/>},
            {path: AMBITION_PATH, element: <Ambition/>},
            {path: TEAM_PATH, element: <TeamController/>},
            {path: AMSTEL_PATH, element: <AmstelPage/>},
            {path: REGISTER_PATH, element: <RegisterPage/>},
            {path: NEWSLETTER_PATH, element: <NewslettersController/>},
            {path: AGENDA_PATH, element: <CalendarController/>},
            {path: YEAR_CALENDAR_PATH, element: <YearCalendarController/>},
            {path: OV_PATH, element: <OvPage/>},
            {path: MR_PATH, element: <MrPage/>},
            {path: PARENTS_ROOM_PATH, element: <ParentsRoomPage/>},
            {path: THINK_TANK_PATH, element: <ThinkTankPage/>},
            {path: DOCUMENTS_PATH, element: <DocumentsController/>},
            {path: VACANCIES_PATH, element: <VacanciesController/>},
            {path: CONTACT_PATH, element: <ContactController/>},
            {path: OPENING_HOURS_PATH, element: <OpeningHoursPage/>},
            {path: LEAVE_PATH, element: <LeaveRequestPage/>},
            {path: COMPLAINTS_PATH, element: <ComplaintsPage/>},
            {
                path: ADMIN_PATH, element: <AdminController/>, children: [
                    {path: ADMIN_DOCUMENTS_PATH, element: <DocumentsPageController/>},
                ]
            },
            {path: '*', element: <Navigate to={HOME_ROUTE}/>}
        ]
    }
];